import React from 'react';
import { Alert, Button, Card, CardContent, Grid, Stack, Typography } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { FDataGrid, FGrid } from '../grid';
import { IExecutiveReviewManager, IExecutiveReviewManagerRow } from './executiveReview.models';

type Props = {
  manager: IExecutiveReviewManager;
  loading?: boolean;
  onOpenReview: (row: IExecutiveReviewManagerRow) => void;
};

type State = {
  selectedReviewId: number | null;
}

class ExecutiveReviewManager extends React.PureComponent<Props> {
  state: State = {
    selectedReviewId: null,
  }

  private columns: any[] = [
    { field: 'reviewcode', headerName: 'Review', width: 180 },
    { field: 'reviewname', headerName: 'Review Name', flex: 1, minWidth: 260 },
    { field: 'statecode', headerName: 'State', width: 150 },
    { field: 'candidatecount', headerName: 'Candidates', width: 120, type: 'number' },
    { field: 'eligiblecount', headerName: 'Eligible', width: 110, type: 'number' },
    {
      field: 'readinessscore',
      headerName: 'Readiness',
      width: 120,
      valueFormatter: (p: any) => `${Number(p.value || 0)}%`,
    },
    { field: 'recommendedscenariocode', headerName: 'Recommended', width: 170 },
    { field: 'lastactivity', headerName: 'Last Activity', width: 190 },

    { field: 'open', headerName: '', width: 80, sortable: false, filterable: false,
      renderCell: (p: any) => (
        <Button
          size="small"
          disabled={!p.row.canopen || this.props.loading}
          onClick={() => p.row.canopen && this.props.onOpenReview(p.row)}

        >
          <OpenInNewIcon fontSize="small" />
        </Button>
      ),
    },
  ];

  render() {
    const m = this.props.manager;
    const s = m.summary;
    return (
      <Stack spacing={2}>
        <Alert severity="info">
          Executive Review is scoped to the current Planning Cycle. Open a dossier to review its submitted Simulation candidates.
        </Alert>

        <Grid container spacing={2}>
          {[
            ['Reviews', s.reviewcount],
            ['Active', s.activecount],
            ['Draft', s.draftcount],
            ['Under Review', s.underreviewcount],
            ['Returned', s.returnedcount],
            ['Recommended', s.recommendedcount],
          ].map(([label, value]) => (
            <Grid size={{ xs: 6, sm: 4, md: 2 }} key={String(label)}>
              <Card elevation={1}>
                <CardContent>
                  <Typography variant="caption" color="text.secondary">{label}</Typography>
                  <Typography variant="h6" sx={{ fontWeight: 900 }}>{value}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* <FGrid
          title="Executive Review Dossiers"
          subtitle={`${m.context.planningcyclename || m.context.planningcyclecode} • ${m.context.fiscalyear || ''}`}
          rows={m.reviews || []}
          columns={this.columns}
          loading={this.props.loading} 
          height={520}
          showQuickFilter
          getRowId={(r: any) => r.reviewid || r.id}
          onRowClick={(p: any) => p.row.canopen && this.props.onOpenReview(p.row)}
          pageSizeOptions={[10, 25, 50]}
        /> */}

        <FDataGrid
          title="Executive Review Dossiers"
          subtitle={`${m.context.planningcyclename || m.context.planningcyclecode} • ${m.context.fiscalyear || ''}`}
          rows={m.reviews || []}
          columns={this.columns}
          loading={this.props.loading}
          height={520}
          selectionMode={'single'}
          showSelectionControl
          selectedRowId={this.state.selectedReviewId}
          onSelectedRowChange={(row) =>
            this.setState({
              selectedReviewId: row
                ? Number((row).reviewid||row.id)
                : null,
            })
          }
          showQuickFilter
          getRowId={(r: any) => r.reviewid || r.id}
          onRowDoubleClick={(p: any) => p.row.canopen && this.props.onOpenReview(p.row)}
          pageSizeOptions={[10, 25, 50]}
        />

        {!m.reviews?.length && (
          <Alert severity="warning">No Executive Review dossier exists for this Planning Cycle.</Alert>
        )}
      </Stack>
    );
  }
}

export default ExecutiveReviewManager;
